import type { Router } from 'next/router';

// Note: This is not a supported way of accessing the Next router.
// Looks to parent in case chat has been iframed.
export const findParentNextRouter = (): Router | undefined => {
  return typeof window !== 'undefined' ? (window.parent as any).next?.router : undefined;
};
